module.exports = __webpack_public_path__ + "img/univfooter.0d1f80a3.svg";